import { onViewLoad } from "~/jose_modern/on_view_load.js";
import { Confirm } from "~/jose_modern/confirm.js";

function init() {
  setupConfirmationValidation();
  setupDisableResetCheckbox();
}

function setupConfirmationValidation() {
  const input = document.getElementById("clear-inventory-confirmation");
  const submit = document.getElementById("clear-inventory-submit");

  if (!input || !submit) return;

  input.addEventListener("input", () => {
    submit.disabled = input.value !== "RESET";
  });
}

function setupDisableResetCheckbox() {
  const checkbox = document.getElementById("clear-inventory-disable-reset");
  if (!checkbox) return;

  checkbox.addEventListener("change", async () => {
    if (!checkbox.checked) return;

    const result = await Confirm.confirm(
      "Are you sure you want to disable resetting inventory data? If you decide to re-enable this, you can contact support.",
      { html: false }
    );

    if (!result || !result.response) {
      checkbox.checked = false;
    }
  });
}

onViewLoad("users#inventory", () => {
  document.addEventListener("clear-inventory-data:init", () => {
    init();
  });
});
